import AoneService from '../axiosbase';
//get station
export const getStation = async (params) => {
  try {
    return await AoneService.get(`addresses/api/v1/stations${params}`);
  } catch (error) {
    return error;
  }
};
//post station
export const postStation = async (data) => {
  try {
    return await AoneService.post(`addresses/api/v1/stations`, data);
  } catch (error) {
    return error;
  }
};

//get station by id
export const getStationbyId = async (params) => {
  try {
    return await AoneService.get(`addresses/api/v1/stations/${params}`);
  } catch (error) {
    return error;
  }
};

//update station
export const updateStation = async (params,data) => {
   try {
     return await AoneService.put(`addresses/api/v1/stations/${params}`,data);
   } catch (error) {
     return error;
   }
 };
//delete station
export const deleteStation = async (params) => {
   try {
     return await AoneService.delete(`addresses/api/v1/stations/${params}`);
   } catch (error) {
     return error;
   }
 };
//partial update station for fields
export const updatePartialStation = async (params,data) => {
   try {
     return await AoneService.patch(`addresses/api/v1/stations/${params}`,data);
   } catch (error) {
     return error;
   }
 };
//station template
export const stationTemplate = async () => {
  try {
    return await AoneService.get(`addresses/api/v1/stations/template/download`, {
      responseType: 'blob',
    });
  } catch (error) {
    return error;
  }
};
//stations bulk upload
export const importStation = async (data) => {
  try {
    return await AoneService.post(`addresses/api/v1/stations/upload`, data, {
      'Content-Type': 'multipart/form-data',
    });
  } catch (error) {
    return error;
  }
};
//retreive station by code and allowed event
export const retrieveStation = async (data) => {
   try {
     return await AoneService.get(`addresses/api/v1/stations/query`,data);
   } catch (error) {
     return error;
   }
 };
//activate station
export const activateStation = async (data) => {
   try {
     return await AoneService.patch(`addresses/api/v1/stations/activate`,data);
   } catch (error) {
     return error;
   }
 };
//deactivate station
export const deactivateStation = async (data) => {
   try {
     return await AoneService.patch(`addresses/api/v1/stations/de-activate`,data);
   } catch (error) {
     return error;
   }
 };
//verify area belongs to centre code
export const verifyAreabyCode = async (params,params2) => {
   try {
     return await AoneService.get(`addresses/api/v1/stations/${params}/validate/area/${params2}`);
   } catch (error) {
     return error;
   }
 };
//retrieve all substations and parent stations by code
export const retrieveSubStationsbyCode = async (params) => {
   try {
     return await AoneService.get(`addresses/api/v1/stations/${params}/subs`);
   } catch (error) {
     return error;
   }
 };
//retrieve all stations and parent stations by code
export const retrieveAllStations = async (params) => {
   try {
     return await AoneService.get(`addresses/api/v1/stations/${params}/parents`);
   } catch (error) {
     return error;
   }
 };
//station summary list
export const getStationSummary = async (params) => {
   try {
     return await AoneService.get(`addresses/api/v1/stations/filter${params}`);
   } catch (error) {
     return error;
   }
 };
export const exportStation = async (params) => {
  try {
    const response = await AoneService.get(
      `addresses/api/v1/stations/download${params}`, 
      { responseType: "blob" }
    );
    return response;
  } catch (error) {
    return error;
  }
};
//Facility Type
export const getFacilityType = async () => {
   try {
     return await AoneService.get(`addresses/api/v1/lookups/FacilityType`);
   } catch (error) {
     return error;
   }
 };
//Facility category
export const getFacilityCategory = async () => {
   try {
     return await AoneService.get(`addresses/api/v1/lookups/FacilityCategory`);
   } catch (error) {
     return error;
   }
 };
 //-------LOCATIONS-------//
 //get locations
 export const getLocation = async (params) => {
   try {
     return await AoneService.get(`addresses/api/v1/locations${params}`);
   } catch (error) {
     return error;
   }
 };
 //post locations
 export const postLocation = async (data) => {
   try {
     return await AoneService.post(`addresses/api/v1/locations`, data);
   } catch (error) {
     return error;
   }
 };
 //update locations
 export const updateLocation = async (params,data) => {
   try {
     return await AoneService.put(`addresses/api/v1/locations/${params}`,data);
   } catch (error) {
     return error;
   }
 };
 //export locations
 export const exportLocation = async (params) => {
  try {
    const response = await AoneService.get(
      `addresses/api/v1/locations/export${params}`, 
      { responseType: "blob" }
    );
    return response;
  } catch (error) {
    return error;
  }
};
//delete location
export const deleteLocation = async (params) => {
  try {
    return await AoneService.delete(`addresses/api/v1/locations/${params}`);
  } catch (error) {
    return error;
  }
};
//template location
export const locationTemplate = async () => {
  try {
    return await AoneService.get(`addresses/api/v1/locations/template/download`, {
      responseType: 'blob',
    });
  } catch (error) {
    return error;
  }
};
//import location
export const importLocation = async (data) => {
  try {
    return await AoneService.post(`addresses/api/v1/locations/import`, data, {
      'Content-Type': 'multipart/form-data',
    });
  } catch (error) {
    return error;
  }
};
 //routes
 //get routes
 export const getRoutes = async (params) => {
  try {
    return await AoneService.get(`addresses/api/v1/routes${params}`);
  } catch (error) {
    return error;
  }
};
 //export routes
 export const exportRoutes = async (params) => {
  try {
    const response = await AoneService.get(
      `addresses/api/v1/routes/export${params}`, 
      { responseType: "blob" }
    );
    return response;
  } catch (error) {
    return error;
  }
};
 //post routes
 export const postRoutes = async (data) => {
  try {
    return await AoneService.post(`addresses/api/v1/routes`,data);
  } catch (error) {
    return error;
  }
};
 //update routes
 export const updateRoutes = async (params,data) => {
  try {
    return await AoneService.put(`addresses/api/v1/routes/${params}`,data);
  } catch (error) {
    return error;
  }
};
 //delete routes
 export const deleteRoutes = async (params) => {
  try {
    return await AoneService.delete(`addresses/api/v1/routes/${params}`);
  } catch (error) {
    return error;
  }
};
//template routes
export const routesTemplate = async () => {
  try {
    return await AoneService.get(`addresses/api/v1/routes/template/download`, {
      responseType: 'blob',
    });
  } catch (error) {
    return error;
  }
};
//import routes
export const importRoutes = async (data) => {
  try {
    return await AoneService.post(`addresses/api/v1/routes/import`, data, {
      'Content-Type': 'multipart/form-data',
    });
  } catch (error) {
    return error;
  }
};
//group lookup
export const getRouteGroup = async () => {
  try {
    return await AoneService.get(`addresses/api/v1/lookups/RouteGroup`);
  } catch (error) {
    return error;
  }
};
//type lookup
export const getRouteType = async () => {
  try {
    return await AoneService.get(`addresses/api/v1/lookups/RouteType`);
  } catch (error) {
    return error;
  }
};